var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"$canvas",staticClass:"ruler",on:{"click":_vm.handleClick,"mouseenter":_vm.handleEnter,"mousemove":_vm.handleMove,"mouseleave":_vm.handleLeave}})}
var staticRenderFns = []

export { render, staticRenderFns }